export default __webpack_public_path__ + "static/media/sia.e7e4baaf.png";